import React from 'react';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import { Section, ParkingCard } from '../../src/components/Layout';
import { Container, Row, Column } from '../../src/components/Grid';
import { H3 } from '../../src/components/Title';
import Icon from '../../src/components/Icon';
import Text from '../../src/components/Typography/Text';
import theme from '../../src/theme';
import Wysiwyg from '../../src/components/Wysiwyg';
import IconSVG from '../../src/components/Icon/IconSVG';

const Content = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 1.7rem;
    color: ${props => props.theme.color.primary};
    text-transform: uppercase;
    letter-spacing: 0.2px;
  }

  p {
    font-size: 1.8rem;
    text-align: left;
    letter-spacing: 0.5px;
    line-height: 2.2rem;
    color: ${props => props.theme.color.darkGrey};
  }
`;

const CustomContent = styled(Content)`
  p:nth-child(1),
  p:nth-child(2),
  p:nth-child(3) {
    color: #3e4143;
  }

  p:nth-child(3) {
    margin-bottom: ${props => props.theme.layout.gutter / 2}px;
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 20px;
`;

const PhoneWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
`;

const Phone = styled.p`
  font-family: ${props => props.theme.font.description.fontFamily};
  font-size: ${props => props.theme.font.description.fontSize};
  line-height: ${props => props.theme.font.description.lineHeight};
  color: ${props => props.theme.color.brand.accent};
`;

const PhoneIcon = styled.div`
  box-sizing: border-box;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${props => props.theme.color.brand.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
`;

class PushParking extends React.PureComponent {
  renderParking = (item, index) => {
    const { detail } = item;

    return (
      <Column key={index} mobile={1} tablet={3} desktop={3} space={10}>
        <ParkingCard
          title={detail.name}
          link={detail.cta_url}
          linkLabel={detail.cta_label}
        >
          <Wysiwyg content={detail.content} />
          {detail.phone && (
            <PhoneWrapper>
              <PhoneIcon>
                <IconSVG name="phone" />
              </PhoneIcon>
              <Phone>{detail.phone}</Phone>
            </PhoneWrapper>
          )}
        </ParkingCard>
      </Column>
    );
  };

  render() {
    const { data, t } = this.props;

    return (
      <Section>
        <Container>
          <Fade up>
            <TitleWrapper>
              <Text
                variant="heading2"
                as="h2"
                color={theme.color.brand.primary}
              >
                {t('common:infos.parking.title')}
              </Text>
            </TitleWrapper>
          </Fade>
          <Fade up>
            <Row space={10}>{data.map(this.renderParking)}</Row>
          </Fade>
        </Container>
      </Section>
    );
  }
}

PushParking.propTypes = {
  data: PropTypes.array.isRequired
};

export default translate()(PushParking);
